"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "auletta": {
    "contrade-ponte": [{
      "hkey": "532b70f8",
      "slug": "auletta",
      "name": "Auletta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8dbb9331": [{
      "hkey": "532b70f8",
      "slug": "auletta",
      "name": "Auletta",
      "primary": true,
      "skipSearch": false
    }],
    "cerreta": [{
      "hkey": "532b70f8",
      "slug": "auletta",
      "name": "Auletta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0a339bb4": [{
      "hkey": "532b70f8",
      "slug": "auletta",
      "name": "Auletta",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;